// extracted by mini-css-extract-plugin
export default {"fullWidth":"op-z","image":"pp-z","lazyLoadPicture":"qp-z","lazyLoadSpinner":"rp-z","lazyLoadSpin":"sp-z","lazyLoadImage":"tp-z","hasStyledAspectRatio":"up-z"};